import { render, staticRenderFns } from "./haokaOrder.vue?vue&type=template&id=0cb4334d&scoped=true&"
import script from "./haokaOrder.vue?vue&type=script&lang=js&"
export * from "./haokaOrder.vue?vue&type=script&lang=js&"
import style0 from "./haokaOrder.vue?vue&type=style&index=0&id=0cb4334d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb4334d",
  null
  
)

export default component.exports